import React from "react";
import GlobalStyles from "styles/GlobalStyles";
import MainLandingPage from "MainLandingPage.js";
import Sessions from "Sessions.js";
import Coaches from "Coaches.js";
import ContactUs from "ContactUs.js";
import Documents from "Documents.js";
// import Shop from "Shop.js";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PageNotFound from "PageNotFound.js";
import Join from "Join.js";
import Login from "components/account/Login";
import Profile from "Profile";
import Verify from "components/account/Verify";
import MembershipDatabase from "membershipDatabase";
import Reports from "Reports";
import MemberDetailsPage from "MemberDetailsPage";
import { ChakraBaseProvider, extendBaseTheme } from "@chakra-ui/react";
import { theme as chakraTheme } from "@chakra-ui/theme";
import tw from "twin.macro";
import PasswordReset from "components/account/PasswordReset";
import DayMembershipForm from "components/forms/DayMembershipForm";
import Juniors from "Juniors";
import ClubChampionships from "ClubChampionships";

const Notice = tw.div`tw-sticky tw-bottom-0 tw-left-0 tw-right-0 tw-py-1 tw-bg-teal-400 tw-text-center tw-mt-auto tw-mb-auto tw-font-bold tw-z-[5000] tw-text-sm`;
const {
  Button,
  Tooltip,
  Tabs,
  Drawer,
  Input,
  Skeleton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  Accordion,
  useToast,
  toast,
  Alert,
  Modal,
  PinInput,
  Form,
  Switch,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  Box,
  Select,
  ButtonGroup,
  FormErrorMessage,
  FocusLock,
  FormControl,
  FormLabel,
  FormError,
  Text,
  IconButton,
  Stack,
  Checkbox,
  CheckboxGroup,
  FormHelperText,
  useDisclosure,
  Textarea,
} = chakraTheme.components;

const theme = extendBaseTheme({
  components: {
    Tooltip,
    Popover,
    CheckboxGroup,
    Text,
    Switch,
    Select,
    FormError,
    Form,
    FormErrorMessage,
    FormHelperText,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton,
    PopoverAnchor,
    Box,
    ButtonGroup,
    FocusLock,
    FormControl,
    FormLabel,
    IconButton,
    Stack,
    useDisclosure,
    PinInput,
    Drawer,
    Button,
    Checkbox,
    Tabs,
    Input,
    Skeleton,
    PopoverContent,
    Accordion,
    useToast,
    toast,
    Alert,
    Modal,
    Textarea,
    PopoverTrigger,
  },
  colors: {
    red: {
      100: "#ff7373",
      200: "#ff5b5b",
      300: "#ff4447",
      400: "#ff2c2c",
      500: "#ff1515",
      600: "#e61313",
      700: "#cc1111",
      800: "#b30f0f",
      900: "#990d0d",
    },
  },
});

export default function App() {
  return (
    <>
      <ChakraBaseProvider theme={theme}>
        <GlobalStyles />
        <Router>
          <Routes>
            <Route path="/sessions" element={<Sessions />} />
            <Route path="/coaches" element={<Coaches />} />
            <Route path="/contact_us" element={<ContactUs />} />
            <Route path="/join" element={<Join />} />
            <Route path="/documents" element={<Documents />} />
            {/* <Route path="/shop" element={<Shop />} /> */}
            <Route path="/login" element={<Login />} />
            <Route path="/passwordreset" element={<PasswordReset />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/daymembership" element={<DayMembershipForm />} />
            <Route path="/juniors" element={<Juniors />} />
            <Route path="/championships" element={<ClubChampionships />} />
            <Route
              path="/membershipdatabase"
              element={<MembershipDatabase />}
            />
            <Route path="/member/*" element={<MemberDetailsPage />} />
            <Route path="/" element={<MainLandingPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Router>
      </ChakraBaseProvider>
      {process.env.REACT_APP_ENVIRONMENT === "staging" && (
        <Notice>STAGING ENVIRONMENT</Notice>
      )}
    </>
  );
}
